import CrossSectionWindow from "../outputs/ui/CrossSection/CrossSectionWindow";
import React from "react";

export default function CrossSectionUI({item}) {
    return (
        <>
            <CrossSectionWindow riverStation={{base_ui_data: item?.base_ui_data, base_title: item?.cross_section}} />
        </>
    )
}